import { render, staticRenderFns } from "./SelectList.vue?vue&type=template&id=5d8440e2&"
import script from "./SelectList.vue?vue&type=script&lang=ts&"
export * from "./SelectList.vue?vue&type=script&lang=ts&"
import style0 from "./SelectList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports